(function () {
  /* A. Precios sin ",00" y etiqueta "SAVE" en español (tema + apps). No toca el checkout. */
  var RX = /(\$\s?\d{1,3}(?:\.\d{3})*),00(?!\d)/g, SV = /\bSAVE\s+(\d+\s?%)/i;
  var SEL = '.price,.price-item,.money,.card-price,[class*="price"],.stc-bar,.sticky-product,.sticky-info,[class*="save"],[class*="badge"],.smsb__p';
  var busy = false, t = 0;
  function walk(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { RX.lastIndex = 0; if (RX.test(n.nodeValue) || SV.test(n.nodeValue)) list.push(n); }
    list.forEach(function (x) { var was = SV.test(x.nodeValue); x.nodeValue = x.nodeValue.replace(RX, '$1').replace(SV, 'AHORRA $1'); if (was && x.parentNode && x.parentNode.style) { x.parentNode.style.background = '#00FF00'; x.parentNode.style.color = '#0b0b0d'; } });
  }
  function fix() {
    busy = true;
    try { var els = document.querySelectorAll(SEL); for (var i = 0; i < els.length; i++) walk(els[i]); } catch (e) {}
    busy = false;
  }
  function later() { if (busy) return; clearTimeout(t); t = setTimeout(fix, 120); }
  function boot() { fix(); try { new MutationObserver(later).observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* B. Fichas propias: tras los botones de compra va la ayuda de talla (antes la empujaba ~150 px hacia abajo). */
  function move() {
    var ctas = document.querySelector('[class$="__ctas"]');
    if (!ctas || !ctas.querySelector('[data-sm-add]')) return;
    var buy = ctas.parentElement, trust = buy.querySelector('[class$="__trust"]');
    if (!trust || buy.getAttribute('data-sm-moved')) return;
    var tip = buy.querySelector('[class$="__tip"]');
    var calc = buy.querySelector('details.sm-shoe') || buy.querySelector('details[class$="__panel"]');
    [tip, calc].forEach(function (el) { if (el) buy.insertBefore(el, trust); });
    buy.setAttribute('data-sm-moved', '1');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move); else move();
})();
